import { Button, Col, FormControl, Row } from 'react-bootstrap'
import { t } from '../locale'
import { ChangeEvt, Communication, CompanyForm } from '../types/stammdaten.type'
import '../css/style.css'

type UnthernamenProps = {
  form: CompanyForm
  handleChangeLocal: (e: ChangeEvt) => void
  history: (path: string, label: string, options?: { value: any; label: string }[]) => void
  handleAddRow: (king: keyof Communication) => void
  handleRemoveRow: (kind: keyof Communication, idx: number) => void
  required: any
}

export default function StammdatenCommunication({
  form,
  handleChangeLocal,
  history,
  handleAddRow,
  handleRemoveRow,
  required,
}: UnthernamenProps) {
  return (
    <>
      <div id='communication-data' className='mb-4'>
        {/* Telefon */}
        <Row className='mt-3'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.communication.phone ? 'required' : ''}`}
            >
              {t('Telefon')}
            </label>
          </Col>
          <Col>
            {form.communication.phone.map((com, idx) => (
              <div key={`phone-${idx}`} className='d-flex align-items-center mb-2'>
                <FormControl
                  name={t('Telefon')}
                  className='w-25 me-3'
                  type='text'
                  placeholder={t('telefonnummer')}
                  id={`communication.phone.${idx}.value`}
                  value={com.value}
                  onChange={handleChangeLocal}
                  required={required.communication.phone}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.communication.phone.${idx}.value`, t('telefonnummer'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
                <FormControl
                  name={t('bemerkung')}
                  className='w-25 me-3'
                  type='text'
                  placeholder={t('bemerkung')}
                  value={com.note}
                  id={`communication.phone.${idx}.note`}
                  onChange={handleChangeLocal}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.communication.phone.${idx}.note`, t('bemerkung'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
                <div className='form-check me-3'>
                  <input
                    name={t('GL')}
                    type='checkbox'
                    className='form-check-input'
                    id={`communication.phone.${idx}.is_gl`}
                    checked={com.is_gl}
                    onChange={handleChangeLocal}
                  />
                  <label
                    className='form-check-label small'
                    htmlFor={`communication.phone.${idx}.is_gl`}
                  >
                    {t('GL')}
                  </label>
                </div>

                <Button
                  variant='light'
                  size='sm'
                  className='ms-2 text-danger border'
                  onClick={() => handleRemoveRow('phone', idx)}
                >
                  X
                </Button>
              </div>
            ))}

            {/* + dugme */}
            <Button
              type='button'
              className='btn btn-light p-0 d-flex align-items-center justify-content-center'
              style={{
                width: '28px',
                height: '28px',
                border: '1px solid #ced4da',
                color: '#198754', // bootstrap green
                fontWeight: 600,
                lineHeight: 1,
              }}
              onClick={() => handleAddRow('phone')}
            >
              +
            </Button>
          </Col>
        </Row>

        {/* E-Mail */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.communication.email ? 'required' : ''}`}
            >
              {t('email')}
            </label>
          </Col>
          <Col>
            {form.communication.email.map((com, idx) => (
              <div key={`email-${idx}`} className='d-flex align-items-center mb-2'>
                <FormControl
                  name={t('email')}
                  className='w-25 me-3'
                  type='text'
                  placeholder={t('eMailAdresse')}
                  id={`communication.email.${idx}.value`}
                  value={com.value}
                  required={required.communication.email}
                  onChange={handleChangeLocal}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.communication.email.${idx}.value`, t('eMailAdresse'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
                <FormControl
                  name={t('bemerkung')}
                  className='w-25 me-3'
                  type='text'
                  placeholder={t('bemerkung')}
                  id={`communication.email.${idx}.note`}
                  value={com.note}
                  onChange={handleChangeLocal}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.communication.email.${idx}.note`, t('bemerkung'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>

                <div
                  className='d-flex align-items-center px-2 py-1 rounded me-3'
                  style={{ backgroundColor: '#FFFFDC' }}
                >
                  <div className='form-check'>
                    <input
                      name={t('rechnung')}
                      type='checkbox'
                      className='form-check-input'
                      id={`communication.email.${idx}.is_invoice`}
                      checked={com.is_invoice}
                      onChange={handleChangeLocal}
                    />
                    <label
                      className='form-check-label small'
                      htmlFor={`communication.email.${idx}.is_invoice`}
                    >
                      {t('rechnung')}
                    </label>
                  </div>
                </div>

                <Button
                  variant='light'
                  size='sm'
                  className='ms-2 text-danger border'
                  onClick={() => handleRemoveRow('email', idx)}
                >
                  X
                </Button>
              </div>
            ))}

            {/* + dugme */}
            <Button
              type='button'
              className='btn btn-light p-0 d-flex align-items-center justify-content-center'
              style={{
                width: '28px',
                height: '28px',
                border: '1px solid #ced4da',
                color: '#198754', // bootstrap green
                fontWeight: 600,
                lineHeight: 1,
              }}
              onClick={() => handleAddRow('email')}
            >
              +
            </Button>
          </Col>
        </Row>

        {/* URL */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label className={`form-control-label ${required.communication.url ? 'required' : ''}`}>
              {t('URL')}
            </label>
          </Col>
          <Col>
            {form.communication.url.map((com, idx) => (
              <div key={`url-${idx}`} className='d-flex align-items-center mb-2'>
                <FormControl
                  name={t('URL')}
                  className='w-25 me-3'
                  type='text'
                  placeholder='URL'
                  id={`communication.url.${idx}.value`}
                  value={com.value}
                  onChange={handleChangeLocal}
                  required={required.communication.url}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.communication.url.${idx}.value`, t('URL'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
                <FormControl
                  name={t('bemerkung')}
                  className='w-25 me-3'
                  type='text'
                  placeholder={t('bemerkung')}
                  id={`communication.url.${idx}.note`}
                  value={com.note}
                  onChange={handleChangeLocal}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.communication.url.${idx}.note`, t('bemerkung'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>

                {/* X dugme*/}
                <Button
                  variant='light'
                  size='sm'
                  className='ms-2 text-danger border'
                  onClick={() => handleRemoveRow('url', idx)}
                >
                  X
                </Button>
              </div>
            ))}

            {/* + dugme */}
            <Button
              type='button'
              className='btn btn-light p-0 d-flex align-items-center justify-content-center'
              style={{
                width: '28px',
                height: '28px',
                border: '1px solid #ced4da',
                color: '#198754', // bootstrap green
                fontWeight: 600,
                lineHeight: 1,
              }}
              onClick={() => handleAddRow('url')}
            >
              +
            </Button>
          </Col>
        </Row>
      </div>
    </>
  )
}
